import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateSet } from "./chunk-PXG64RU4.js"; // src/focusManager.ts

import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";

var _focused, _cleanup, _setup;

var FocusManager = /*#__PURE__*/function (_Subscribable) {
  function FocusManager() {
    var _this2;

    _classCallCheck(this, FocusManager);

    _this2 = _callSuper(this, FocusManager);

    __privateAdd(_this2, _focused);

    __privateAdd(_this2, _cleanup);

    __privateAdd(_this2, _setup);

    __privateSet(_this2, _setup, function (onFocus) {
      if (!isServer && window.addEventListener) {
        var listener = function listener() {
          return onFocus();
        };

        window.addEventListener("visibilitychange", listener, false);
        return function () {
          window.removeEventListener("visibilitychange", listener);
        };
      }

      return;
    });

    return _this2;
  }

  _inherits(FocusManager, _Subscribable);

  return _createClass(FocusManager, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      if (!__privateGet(this, _cleanup)) {
        this.setEventListener(__privateGet(this, _setup));
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      var _a;

      if (!this.hasListeners()) {
        (_a = __privateGet(this, _cleanup)) == null ? void 0 : _a.call(this);

        __privateSet(this, _cleanup, void 0);
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(setup) {
      var _this3 = this;

      var _a;

      __privateSet(this, _setup, setup);

      (_a = __privateGet(this, _cleanup)) == null ? void 0 : _a.call(this);

      __privateSet(this, _cleanup, setup(function (focused) {
        if (typeof focused === "boolean") {
          _this3.setFocused(focused);
        } else {
          _this3.onFocus();
        }
      }));
    }
  }, {
    key: "setFocused",
    value: function setFocused(focused) {
      var changed = __privateGet(this, _focused) !== focused;

      if (changed) {
        __privateSet(this, _focused, focused);

        this.onFocus();
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var isFocused = this.isFocused();
      this.listeners.forEach(function (listener) {
        listener(isFocused);
      });
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      var _a;

      if (typeof __privateGet(this, _focused) === "boolean") {
        return __privateGet(this, _focused);
      }

      return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
  }]);
}(Subscribable);

_focused = new WeakMap();
_cleanup = new WeakMap();
_setup = new WeakMap();
var focusManager = new FocusManager();
export { FocusManager, focusManager };